import { Component, Input, Output, EventEmitter } from '@angular/core';
import { OrderHistoryEvent } from '../../../models-otc/order-history-event.model';

const ENTITY_CONFIG: Record<string, { icon: string; color: string }> = {
    ORDER: { icon: 'receipt_long', color: '#1976d2' },
    ORDER_ITEM: { icon: 'inventory_2', color: '#f9a825' },
    NOTE: { icon: 'sticky_note_2', color: '#00897b' },
    SAP: { icon: 'sync', color: '#7b1fa2' }
};

const NO_DETAIL_EVENTS = [
    'ORDER_SUBMITTED_TO_SAP',
    'SAP_SUBMISSION_SUCCESS',
    'ORDER_REJECTED',
    'ORDER_RESUBMITTED'
];

@Component({
    selector: 'app-order-history-event',
    templateUrl: './order-history-event.component.html',
    styleUrls: ['./order-history-event.component.css'],
    standalone: false
})
export class OrderHistoryEventComponent {
    @Input() event: OrderHistoryEvent;
    @Input() isExpanded = false;
    @Output() toggleExpand = new EventEmitter<void>();

    get entityConfig() {
        if (this.event?.eventType === 'ITEM_DELETED') {
            return { icon: 'delete', color: '#c62828' };
        }
        return ENTITY_CONFIG[this.event?.entityType] || ENTITY_CONFIG['ORDER'];
    }

    get eventLabel(): string {
        if (!this.event?.eventType) return '';
        return this.event.eventType
            .split('_')
            .map(w => w.charAt(0) + w.slice(1).toLowerCase())
            .join(' ');
    }

    get hasDetail(): boolean {
        if (!this.event) return false;
        if (NO_DETAIL_EVENTS.includes(this.event.eventType)) return false;
        return !!(this.event.oldValue || this.event.newValue);
    }
}
